var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"d-flex align-items-end justify-content-end my-1"},[_c('b-link',{staticClass:"card-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.examen_avanza()}}},[_vm._v("Examen")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }